import { render, staticRenderFns } from "./BedSizeList.vue?vue&type=template&id=3843aa44&scoped=true"
import script from "./BedSizeList.vue?vue&type=script&lang=js"
export * from "./BedSizeList.vue?vue&type=script&lang=js"
import style0 from "./BedSizeList.vue?vue&type=style&index=0&id=3843aa44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843aa44",
  null
  
)

export default component.exports